import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=40baab1d&scoped=true&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=40baab1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40baab1d",
  null
  
)

export default component.exports